import "./Footer.css";

function Footer() {
  return (
    <footer className="footer">
      <h3>Kalesh Bricks</h3>

      <p>Address: Hie tech city , Hyderabad</p>

      <p>Phone: +91 8520823389</p>

      <p>Email: medarametlakalesh@gmail.com</p>

      <p>© 2026 Kalesh Bricks. All Rights Reserved.</p>
    </footer>
  );
}

export default Footer;